import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { setupOfflineInterceptor } from "@/lib/axiosOffline";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("React Error Boundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', background: '#09090b', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ textAlign: 'center', maxWidth: 400 }}>
            <h1 style={{ color: '#fbbf24', fontSize: 24, marginBottom: 12 }}>Error del Sistema</h1>
            <p style={{ color: '#a1a1aa', fontSize: 14, marginBottom: 16 }}>{this.state.error?.message || 'Ocurrio un error inesperado'}</p>
            <button onClick={() => { localStorage.clear(); window.location.href = '/'; }}
              style={{ background: '#fbbf24', color: '#09090b', border: 'none', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
              Reiniciar App
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__kjInstallPrompt = e;
  window.dispatchEvent(new Event('kj-install-available'));
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Setup offline-aware axios interceptor (queues writes when offline)
setupOfflineInterceptor();

// Hide badge during scroll
let scrollTimer;
window.addEventListener('scroll', () => {
  document.body.classList.add('is-scrolling');
  clearTimeout(scrollTimer);
  scrollTimer = setTimeout(() => document.body.classList.remove('is-scrolling'), 1200);
}, true);
